export default "__VITE_ASSET__8140d38c__"